const controlSelector = '[data-cross-sell-carousel-button]';

function getCarouselState(carousel) {
  const cells = Array.from(carousel.children).filter((cell) => !cell.hidden);
  if (!cells.length) return null;

  const firstCellLeft = cells[0].offsetLeft;
  const cellStep = cells[1] ? cells[1].offsetLeft - firstCellLeft : cells[0].clientWidth;
  const visibleCount = Math.max(1, Math.round(carousel.clientWidth / cellStep));
  const maxIndex = Math.max(0, cells.length - visibleCount);
  const currentScroll = Math.abs(carousel.scrollLeft);
  const positions = cells.map((cell) => Math.max(0, cell.offsetLeft - firstCellLeft));
  const index = Math.min(maxIndex, positions.reduce((nearestIndex, position, itemIndex) => {
    return Math.abs(position - currentScroll) < Math.abs(positions[nearestIndex] - currentScroll)
      ? itemIndex
      : nearestIndex;
  }, 0));

  return { cells, positions, visibleCount, maxIndex, index };
}

function updateControls(carousel, forcedIndex) {
  if (!carousel?.id) return;

  const state = getCarouselState(carousel);
  if (!state) return;

  const index = forcedIndex ?? state.index;

  document.querySelectorAll(`${controlSelector}[aria-controls="${carousel.id}"]`).forEach((button) => {
    const isPrevious = button.dataset.direction === 'previous';
    button.disabled = isPrevious ? index <= 0 : index >= state.maxIndex;
  });

  document.querySelectorAll(`[data-cross-sell-carousel-status][aria-controls="${carousel.id}"]`).forEach((status) => {
    const firstVisible = index + 1;
    const lastVisible = Math.min(index + state.visibleCount, state.cells.length);
    status.textContent = state.visibleCount > 1
      ? `${firstVisible}-${lastVisible} / ${state.cells.length}`
      : `${firstVisible} / ${state.cells.length}`;
  });
}

document.addEventListener('click', (event) => {
  const button = event.target.closest(controlSelector);
  if (!button) return;

  const carousel = document.getElementById(button.getAttribute('aria-controls'));
  if (!carousel) return;

  event.preventDefault();
  const state = getCarouselState(carousel);
  if (!state) return;

  const direction = button.dataset.direction === 'previous' ? -1 : 1;
  const targetIndex = Math.max(0, Math.min(state.maxIndex, state.index + direction));
  const targetLeft = Math.min(state.positions[targetIndex], carousel.scrollWidth - carousel.clientWidth);

  carousel.scrollTo({ left: targetLeft, behavior: 'smooth' });
  updateControls(carousel, targetIndex);
  window.setTimeout(() => updateControls(carousel), 450);
});

document.addEventListener('scroll', (event) => {
  if (event.target.matches?.('scroll-carousel.complementary-products')) {
    updateControls(event.target);
  }
}, true);

function initializeCrossSellCarousels(root = document) {
  root.querySelectorAll?.('scroll-carousel.complementary-products').forEach((carousel) => updateControls(carousel));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeCrossSellCarousels());
} else {
  initializeCrossSellCarousels();
}

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches?.('scroll-carousel.complementary-products')) updateControls(node);
    initializeCrossSellCarousels(node);
  }));
}).observe(document.documentElement, { childList: true, subtree: true });
